export default class Contact{
    id;
    published;
    image_id;

    constructor(){    
        this.access_groups = [];
        this.created = new Date();
        this.avatar = "";
        this.published = false;
        this.created_at = new Date();
        this.updated_at = new Date();

        this.first_name = "";
        this.last_name = "";
        this.organisation = "";
        this.phone = "";
        this.mobile = "";
        this.notes = "";
        this.email = "";
        this.is_owner = false;
        this.user_blocked = false;
        this.created_by_contact = 0;
        this.updated_by_contact = 0;
    } 
}
